import { COLOR4, WHITE, RADIO_COLOR, ORIENTAL_ORANGE } from '../../constants';

export const CommonModalStyles = {
  card_content: {
    textAlign: 'center',
    padding: '0px !important',
    margin: '0px',
  },

  btnAlign: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  saveAndExit_Close: {
    background: `${RADIO_COLOR} 0% 0% no-repeat padding-box`,
    color: COLOR4,
    height: '40px',
    padding: '12px 15px',
    letterSpacing: '0.1px',
    font: 'normal 700 14px/16px Arial',
    width: '136px',
    opacity: 1,
    textTransform: 'none',
    borderRadius: '23px',
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: `2px`,
    },
  },

  back_button: {
    border: `1px solid ${RADIO_COLOR}`,
    borderRadius: '25px',
    opacity: 1,
    maxHeight: '40px',
    maxWidth: '136px',
    padding: '12px 36px',
    margin: '0px 15px 0px 0px',
    font: 'normal 700 14px/16px Arial',
    letterSpacing: '1.01px',
    color: `${RADIO_COLOR} !important`,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: COLOR4,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: `2px`,
    },
  },

  button_cancel: {
    width: '100%',
    height: '40px',
    borderRadius: '56px',
    fontSize: '14px',
    lineHeight: '16px',
    textAlign: 'center',
    fontStyle: 'normal',
    fontWeight: '700',
    color: '#661c69',
    textTransform: 'none',
    borderColor: '#661c69',
    outlineColor: '#661c69',
    background: '#ffffff',
  },

  backdrop: {
    zIndex: 1301,
    display: 'flex',
    justifyContent: 'center',
    color: WHITE,
    alignItems: 'center',
  },

  root: {
    display: 'flex',
    maxWidth: '332px',
    alignItems: 'center',
    maxHeight: '290px',
    borderRadius: '10px',
    boxShadow: '0px 4px 12px rgba(62, 64, 70, 0.08)',
    '@media (max-width:400px)': {
      maxHeight: 'unset',
    },
  },

  rootThankYou: {
    alignItems: 'center',
    maxWidth: '432px',
    borderRadius: '10px',
    display: 'flex',
    boxShadow: '0px 4px 12px rgba(62, 64, 70, 0.08)',
    padding: '35px 36px 40px 36px',
  },

  textOneStyle: {
    fontStyle: 'normal',
    marginBottom: '20px',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '18px',
    textAlign: 'center',
    color: '#00000',
  },

  textOneThankyou: {
    font: 'normal 700 14px/16px Arial',
    color: '#00000',
    textAlign: 'start',
  },

  textNameSubThankyou: {
    font: 'normal 400 14px/16px Arial',
    textAlign: 'start',
    color: '#00000',
  },

  textTwoThankyou: {
    font: 'normal 400 12px/15px Arial',
    textAlign: 'start',
    color: '#00000',
  },

  imageThankyou: {
    margin: '0px 20px 0px 10px',
  },

  modal_close: {
    textAlign: 'right',
    height: '35px',
    color: RADIO_COLOR,
  },

  profilePic: {
    width: '90px',
    height: '90px',
    border: '4px solid #E37617',
    borderRadius: '50%',
    marginRight: '29px',
  },

  imageProfile: {
    borderRadius: '50%',
    height: '90px',
    overflow: 'hidden',
    width: '90px',
  },

  closeOverlayThankyou: {
    top: '42px',
    color: COLOR4,
    cursor: 'pointer',
    height: '28px',
    position: 'relative',
    width: '28px',
    right: '19px',
  },

  closeOverlay: {
    top: '29px',
    width: '28px',
    color: COLOR4,
    cursor: 'pointer',
    height: '28px',
    position: 'relative',
    background: ORIENTAL_ORANGE,
    '&:hover': {
      backgroundColor: ORIENTAL_ORANGE,
    },
  },
};
